import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, TextField } from '@mui/material'
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { addGen } from '../../store/Machine/actions';

function AddFormGen({ open, setOpen, id }) {
    const dispatch = useDispatch()

    const [title, setTitle] = useState('');

    const handleClose = () => {
        setOpen(false);
    };

    const handleSend = (e) => {
        e.preventDefault()

        dispatch(addGen({
            "type_id": id,
            "title": title
        }))

        setOpen(false)
        setTitle('')
    }

    return (
        <Dialog open={open} onClose={() => handleClose(false)}>
            <form
                onSubmit={(e) => handleSend(e)}
                autoComplete="off"
            >
                <DialogTitle>
                    Добавить поколение
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <FormControl>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="nomer"
                            label="Поколение"
                            type="text"
                            fullWidth
                            variant="outlined"
                            required={true}
                            value={title}
                            onChange={e => setTitle(e.target.value)}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button type="submit">Добавить</Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}

export default AddFormGen